"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatedRoute = void 0;
var tslib_1 = require("tslib");
var react_oidc_context_1 = require("@axa-fr/react-oidc-context");
var react_1 = tslib_1.__importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AuthenticatedRoute = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement(react_router_dom_1.Route, tslib_1.__assign({}, rest),
        react_1.default.createElement(react_oidc_context_1.OidcSecure, null, children)));
};
exports.AuthenticatedRoute = AuthenticatedRoute;
//# sourceMappingURL=index.js.map